import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, isRef as _isRef, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../assets/imgs/logo.png'


const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = {
  key: 0,
  class: "wx-bind-tip-bar"
}
const _hoisted_3 = {
  key: 1,
  class: "logo",
  src: _imports_0,
  alt: "蛋糕叔叔"
}
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "level-circle" }
const _hoisted_6 = { class: "grid-content" }
const _hoisted_7 = { class: "grid-content" }
const _hoisted_8 = { class: "carousel-container" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "status"
}
const _hoisted_11 = {
  key: 1,
  class: "status"
}
const _hoisted_12 = {
  key: 4,
  class: "show_text",
  style: {"text-align":"right","padding":"10px"}
}
const _hoisted_13 = {
  key: 5,
  class: "loading-mask"
}
const _hoisted_14 = { key: 6 }
const _hoisted_15 = { class: "box" }
const _hoisted_16 = { class: "data-show other" }
const _hoisted_17 = { class: "top" }
const _hoisted_18 = { class: "show_data" }
const _hoisted_19 = { class: "show_data" }
const _hoisted_20 = { class: "show_data" }
const _hoisted_21 = { class: "show_data" }
const _hoisted_22 = { class: "show_data" }
const _hoisted_23 = { class: "top" }
const _hoisted_24 = { class: "show_data" }
const _hoisted_25 = { class: "show_data" }
const _hoisted_26 = { class: "show_data" }
const _hoisted_27 = { class: "show_data" }
const _hoisted_28 = { class: "show_data" }
const _hoisted_29 = { class: "box" }
const _hoisted_30 = { class: "shelf-data" }
const _hoisted_31 = { class: "bar" }
const _hoisted_32 = { class: "box" }
const _hoisted_33 = { class: "data-show" }
const _hoisted_34 = {
  class: "left",
  style: {"width":"400px"}
}
const _hoisted_35 = { key: 7 }
const _hoisted_36 = {
  style: {"margin-left":"15px"},
  class: "grid-content"
}
const _hoisted_37 = { class: "box" }
const _hoisted_38 = { class: "data-show other" }
const _hoisted_39 = { class: "top" }
const _hoisted_40 = {
  class: "show",
  style: {"margin":"10px 70px","align-items":"center"}
}
const _hoisted_41 = {
  class: "show_data",
  style: {"margin-left":"-25px"}
}
const _hoisted_42 = { style: {"margin-left":"20px"} }
const _hoisted_43 = {
  class: "show",
  style: {"margin":"10px 70px","align-items":"center"}
}
const _hoisted_44 = { class: "show_data" }
const _hoisted_45 = { style: {"margin-left":"20px"} }
const _hoisted_46 = {
  class: "show",
  style: {"margin":"10px 70px","align-items":"center"}
}
const _hoisted_47 = { class: "show_data" }
const _hoisted_48 = { style: {"margin-left":"20px"} }
const _hoisted_49 = {
  class: "top",
  style: {"justify-content":"center"}
}
const _hoisted_50 = {
  class: "show",
  style: {"flex-direction":"row","flex":"0"}
}
const _hoisted_51 = { style: {"display":"flex","flex-direction":"column","align-items":"stretch","border-right":"1px solid #ccc"} }
const _hoisted_52 = {
  class: "show_data",
  style: {"margin":"10px 35px","padding":"10px","width":"100px"}
}
const _hoisted_53 = { style: {"display":"flex","flex-direction":"column","align-items":"stretch"} }
const _hoisted_54 = {
  class: "show_data",
  style: {"margin":"10px 35px","padding":"10px","width":"100px"}
}
const _hoisted_55 = { class: "dialog-footer" }
const _hoisted_56 = { class: "header-title" }
const _hoisted_57 = { ref: "innerRef" }
const _hoisted_58 = ["innerHTML"]
const _hoisted_59 = { class: "dialog-footer" }
const _hoisted_60 = { class: "content" }
const _hoisted_61 = { class: "dialog-footer" }
const _hoisted_62 = { class: "content" }
const _hoisted_63 = { class: "dialog-footer" }
const _hoisted_64 = { class: "dialog-footer" }
const _hoisted_65 = { class: "content" }
const _hoisted_66 = { class: "dialog-footer" }
const _hoisted_67 = { class: "content" }
const _hoisted_68 = { class: "dialog-footer" }
const _hoisted_69 = { class: "content" }
const _hoisted_70 = { class: "dialog-footer" }
const _hoisted_71 = {
  class: "content",
  style: {"text-align":"center"}
}
const _hoisted_72 = { class: "dialog-footer" }

import { getCurrentInstance, reactive, ref, watch, nextTick, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from '@/store'
import { updateVersionApi } from '@/apis/merchant'
import { existDelayProductApi } from '@/apis/product'
import * as echarts from 'echarts'
import { VideoCameraFilled,Clock,Tools, DocumentCopy,DocumentDelete,DocumentChecked,Ticket,Sell,Stamp,Loading,Avatar, WarningFilled, Close} from '@element-plus/icons-vue'
import { getDelayTime, dateFormat } from '@/utils/index'
import SelectBrand from '@/components/SelectBrand.vue'
import { UserType } from '@/enums/user'
import MerchantQualificationDialog from './components/MerchantQualificationDialog.vue'
import { UserMutationTypes } from '@/store/modules/user/mutation-types'


export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const router = useRouter()
const store = useStore()
const userData = store.state.user
const shopRuleData = userData.shopRuleData as any
const staleDatedMsg = userData.staleDatedMsg
const obligationMsg = userData.obligationMsg
const ratingMsg = userData.ratingMsg
const reconciliationMsg = userData.reconciliationMsg
const StockMsg = userData.StockMsg
const { proxy } = getCurrentInstance() as any
const userGroups = userData.userInfo.group_id.split(',')
const user_id = userData.userInfo.id as string
const is_contracts = userData.is_contracts as number // 商户法人信息完善提示弹框

/**
 * timeout_count：是否存在未审核的罚款申诉，有则进行弹框提示
*/
const { user_type, parent_id, is_cat, group_id, timeout_count } = userData.userInfo as any

const showFineAppealDialog = timeout_count > 0 && !sessionStorage.getItem('fineAppealDialog') // 未审核的罚款申诉的提示弹框
const setSessionAndRedirect = () => {
    sessionStorage.setItem('fineAppealDialog', '1')
    router.push('/check/appeal-list')
}

// 微信授权绑定提示
const wxBindStatus = ref(localStorage.getItem('wxBindStatus'))
const showWxBindTip = ref(wxBindStatus.value !== '1' && !userData.userInfo.unionid)

// 跳转到换绑微信授权页
const goWxAuth = () => {
    router.push('/my/change-wx-bind')
}

// 关闭微信授权提示
const dismissWxTip = () => {
    showWxBindTip.value = false
    sessionStorage.setItem('wxBindTipDismissed', '1')
}

const today = new Date()
const filters = reactive({
    brand_id:'',
    start_time: dateFormat(`${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`), //开始日期
    end_time: dateFormat(`${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`), //结束日期
})

const finance = reactive({
    brand_count:'',
    cake_total_amount:'',
    coupon_total_amount:'',
    movie_total_amount:'',
    user_count:'',   
    end_time:''
})
const financeFilters = reactive({
    start_time: dateFormat(new Date(today.getFullYear(), 0, 1)), //开始日期
    end_time: finance.end_time, //结束日期
})
const newFilters = reactive({
    start_date: dateFormat(new Date(today.getFullYear(), 0, 1)), //开始日期
    end_date: finance.end_time, //结束日期
})
// 系统更新提示框
const sysDialog = ref(false)

// 商户法人信息完善提示弹框
const merchantQualificationDialogShow = ref((is_contracts == 2 || is_contracts == 3) && !sessionStorage.getItem('merchant_qualification_dialog'))

// 一开始同意按钮不显示
const agree = ref(true)
const state = reactive({
    level:'',//级别
    type:9,//库存不足下架
    dialogStockVisible:false,//库存不足下架弹窗
    dialogStandardVisible: false,//规范弹窗显示
    currentRuleIndex: 0, // 当前显示的规则索引
    dialogStaleDatedVisible:false,//资质过期提醒弹窗
    dialogCakeCatVisible:false,//完善商品分类提醒弹窗
    dialogBrandVisible:false,//未付款品牌提醒弹窗
    dialogRatingVisible:false,//商家评级提醒弹窗
    order_count: 0,//订单数量
    delivery_count: 0,//待发货订单
    unshipped_count: 0,//48h未发货订单
    bad_count: 0,//差评订单
    sale_count: 0,//在售商品
    fine_count: 0,//罚款金额
    sale_money_count: 0,//销售金额
    customer_price_count: 0,//客单价
    business_money_count: 0,//商家实收
    check_count: 0,//待审核商品
    self_removal: 0,//自行下架
    new_data: '',//数据更新时间
    delivery_shelf: '',//系统下架-延迟发货
    delivery_shelf_rate:'',//系统下架-延迟发货占比    
    over_shelf: 0,//系统下架-品牌资质过期 
    over_shelf_rate: 0,//系统下架-品牌资质过期占比 
    stock_shelf:0,//系统下架-库存不足
    stock_shelf_rate:0,//系统下架-库存不足占比
    product_shelf: 0,//运营下架-商品溢价 
    product_shelf_rate: 0,//运营下架-商品溢价占比
    discount_shelf: 0,//运营下架-折扣不合格 
    discount_shelf_rate: 0,//运营下架-折扣不合格占比 
    info_shelf: [],//运营下架-信息有误
    info_shelf_rate: [],//运营下架-信息有误占比
    quality_shelf: [],//运营下架-质量问题
    quality_shelf_rate: [],//运营下架-质量问题占比
    taste_shelf: [],//运营下架-口感不佳
    taste_shelf_rate: [],//运营下架-口感不佳占比
    other_shelf: [],//运营下架-其他
    other_shelf_rate: [],//运营下架-其他占比
    date: [],//返回日期
    table_data: [],//商品排行
    sale_money: [],//销售额
    customer_price: [],//客单价
    business_money: [],//商家实收
    isLoading: true, // 控制加载动画显示和隐藏
    
    dialogReconciliationVisible:false,//对账提醒弹窗
})
const correlation = reactive ({
    yi_jiesuan_amount: 0,//已结算金额
    ying_jiesuan_amount: 0,//应结算金额
    zz_jm_amount: 0,//最终罚款金额
    jm_amount: 0,//罚款减免金额
})
const noticeDate = ref([])
const toOrder= (type,t:any) => {
    router.push(`/merchant-admin/order-list?o=${type}&t=${t}&start_date=${filters.start_time}&end_date=${filters.end_time}`);
}
const toOrderAll= (type,all:any) => {
    router.push(`/merchant-admin/order-list?o=${type}&all=${all}&start_date=${filters.start_time}&end_date=${filters.end_time}`);
}
const toBadOrder= (type,num) => {
    router.push(`/merchant-admin/bad-list?o=${type}&num=${num}&start_date=${filters.start_time}&end_date=${filters.end_time}`);
}
const toProduct= (type,status) => {
    router.push(`/merchant-admin/product-list?o=${type}&status=${status}`);
}
const toFine= (type) => {
    router.push(`/merchant-admin/fine-list?o=${type}&start_date=${filters.start_time}&end_date=${filters.end_time}`);
}
const toFineNew= (type,AppealStatus) => {
    router.push(`/merchant-admin/fine-list?o=${type}&start_date=${newFilters.start_date}&end_date=${newFilters.end_date}&AppealStatus=${AppealStatus}`);
}
const toSale= (type) => {
    router.push('/merchant-admin/sale-list?o=' + type);
}
const toSaleNew= (type,status) => {
    router.push(`/merchant-admin/sale-list?o=${type}&start_date=${newFilters.start_date}&end_date=${newFilters.end_date}&remittance_status=${status}`);
}
const toCheck= (type) => {
    router.push('/merchant-admin/product-check-list?o=' + type);
}
const getNoticeList = () => {
    proxy.$http.get('/ptapi/Brand/get_shop_mail_list').then(res => {
        const { code, data, msg } = res
        if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
        //此处遍历到时取消
        noticeDate.value = data.data
            })
}
// 跳转至编辑页
const toNotice = (id,t) => {
    router.push(`/merchant-admin/message-edit?id=${id}&t=${t}`) 
    .then(success => {
        console.error('Route push success:', success);
    })
    .catch(failure => {
        // 导航失败（被拦截，导航错误等）
        console.error('Route push failed:', failure);
    });
}
const disabledNewEndDate = (date) => { // 返回不可用日期
    return date.getTime() > Date.now()
}
const disabledFinanceEndDate = (date) => { // 返回不可用日期
    return date.getTime() >= Date.now() - 1000*60*60*24
}
//获取相关金额
const getCorrelationList = () => {
    //@ts-ignore
    proxy.$http.get('/admin/Merchant/shop_order_fine', newFilters).then(res => {
        const { code, data, msg } = res
        if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
        Object.assign(correlation, data)
    })   
}
const getList = () => {
    return
    //@ts-ignore
    proxy.$http.get('/admin/merchant/order_data_show', filters).then(res => {
        const { code, data, msg } = res
        if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
        Object.assign(state, data)
        // initSystemEcharts()
        // initSystemShelfEcharts()
        // initOperateEcharts()
        // initLineMoreEcharts()
        state.isLoading = false
    })
}
//获取财务数据
const getFinanceList = () => {
    //@ts-ignore
    proxy.$http.get('/admin/merchant/finance_data_board', financeFilters).then(res => {
        const { code, data, msg } = res
        if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
        Object.assign(finance, data)
        
    })
}
const onBrandChange = (val) => {
    filters.brand_id = val
}
const onDay = (type) => {
    let current = dateFormat(`${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`);
    let week = getDelayTime(current, -7, 'date')
    let month = getDelayTime(current, -30, 'date')
    switch (type) {
        case 2:
            //@ts-ignore
            filters.start_time = week;
            //@ts-ignore
            filters.end_time = current;
            break;
        case 3:
            //@ts-ignore
            filters.start_time = month;
            //@ts-ignore
            filters.end_time = current;
        default:
            break;
    }
    getList()
}
const search = () => {
    if (filters.start_time && filters.end_time) {
        if (filters.end_time >= filters.start_time) {
            state.isLoading = true
            getList()
        } else {
            proxy.$message({ type: 'error', message: '结束时间不能早于开始时间' })
        }
    }else{
        proxy.$message({ type: 'error', message: '日期不能为空' })
    }
}

const searchTo = () => {
    if (newFilters.start_date && newFilters.end_date) {
        if (newFilters.end_date >= newFilters.start_date) {
            state.isLoading = true
            // getCorrelationList()
        } else {
            proxy.$message({ type: 'error', message: '结束时间不能早于开始时间' })
        }
    }else{
        proxy.$message({ type: 'error', message: '日期不能为空' })
    }
}
const searchFinance = () => {
    if (filters.start_time && filters.end_time) {
        if (filters.end_time >= filters.start_time) {
            state.isLoading = true
            getFinanceList()
        } else {
            proxy.$message({ type: 'error', message: '结束时间不能早于开始时间' })
        }
    }else{
        proxy.$message({ type: 'error', message: '日期不能为空' })
    }
}
//@ts-ignore
const disabledStartDate = (date) => { // 返回开始不可用日期
    //所选时间小于等于当前日期
    var start = date.getTime()
    var current = Date.now()
    return start > current
}
//@ts-ignore
const disabledEndDate = (date) => { // 返回结束不可用日期
    //@ts-ignore
    var start = new Date(filters.start_time).getTime() - 24*60*60*1000
    //所选时间小于等于当前日期
    //@ts-ignore
    var end = date.getTime() 
    var current = Date.now() 
    //所选时间小于等于当前日期或小于开始日期
    return end > current || end < start
}
const initSystemEcharts = () => {
    //  基于准备好的dom，初始化echarts实例
    let myChart = echarts.init(document.getElementById('system_dialog')!);
    // 指定图表的配置项和数据
    let option = {
        title: {
            text: '系统下架',
            left: 'left'
        },
        tooltip: {
            trigger: 'item'
        },
        legend: {
            top: '1%',
            right: 'right'
        },
        series: [
            {
                name: '系统下架比例',
                type: 'pie',
                radius: ['40%', '70%'],
                avoidLabelOverlap: false,
                label: {
                    show: false,
                    position: 'center'
                },
                emphasis: {
                    label: {
                        show: false,
                        fontSize: 40,
                        fontWeight: 'bold'
                    }
                },
                labelLine: {
                    show: false
                },
                data: [
                    { value: state.delivery_shelf, name: '延迟发货' + state.delivery_shelf_rate },
                    { value: state.over_shelf, name: '品牌资质过期' + state.over_shelf_rate },
                    { value: state.stock_shelf, name: '库存不足' + state.stock_shelf_rate },

                ]
            }
        ]
    };
        option && myChart.setOption(option);
}
const initSystemShelfEcharts = () => {
    //  基于准备好的dom，初始化echarts实例
    let myChart = echarts.init(document.getElementById('removal_dialog')!);
    // 指定图表的配置项和数据
    let option = {
        title: {
            text: '自行下架',
            left: 'left'
        },
        tooltip: {
            trigger: 'item'
        },
        legend: {
            top: '1%',
            right: 'right'
        },
        series: [
            {
                name: '自行下架比例',
                type: 'pie',
                radius: ['40%', '70%'],
                avoidLabelOverlap: false,
                label: {
                    show: false,
                    position: 'center'
                },
                emphasis: {
                    label: {
                        show: false,
                        fontSize: 40,
                        fontWeight: 'bold'
                    }
                },
                labelLine: {
                    show: false
                },
                data: [
                    { value: state.self_removal, name: '自行下架100%'  },
                ]
            }
        ]
    };
        option && myChart.setOption(option);
}
const initOperateEcharts = () => {
    //  基于准备好的dom，初始化echarts实例
    let myChart = echarts.init(document.getElementById('operate_dialog')!);
    // 指定图表的配置项和数据
    let option = {
        title: {
            text: '运营下架',
            left: 'left'
        },
        tooltip: {
            trigger: 'item'
        },
        legend: {
            top: '-9%',
            right: 'right'
        },
        series: [
            {
                name: '运营下架比例',
                type: 'pie',
                radius: ['40%', '70%'],
                avoidLabelOverlap: false,
                label: {
                    show: false,
                    position: 'center'
                },
                emphasis: {
                    label: {
                        show: false,
                        fontSize: 40,
                        fontWeight: 'bold'
                    }
                },
                labelLine: {
                    show: false
                },
                data: [
                    { value: state.product_shelf, name: '商品溢价' + state.product_shelf_rate },
                    { value: state.discount_shelf, name: '折扣不合格' + state.discount_shelf_rate },
                    { value: state.info_shelf, name: '信息有误' + state.info_shelf_rate },
                    { value: state.quality_shelf, name: '质量问题' + state.quality_shelf_rate },
                    { value: state.taste_shelf, name: '口感不佳' + state.taste_shelf_rate },
                    { value: state.other_shelf, name: '其他' + state.other_shelf_rate },
                ]
            }
        ]
    };
    option && myChart.setOption(option);
}
const initLineMoreEcharts = () => {
    //  基于准备好的dom，初始化echarts实例
    let myChart = echarts.init(document.getElementById('member_user')!);
    // 指定图表的配置项和数据
    let option = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
                crossStyle: {
                    color: '#999'
                }
            }
        },
        legend: {
            data: ['销售额', '商家实收']
        },
        toolbox: {
            show: true,
            orient: 'vertical',
            left: 'right',
            top: 'center',
            feature: {
            mark: { show: true },
            // dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ['stack'] },
            restore: { show: true },
            saveAsImage: { show: true }
            }
        },
        xAxis: [
            {
            type: 'category',
            axisTick: { show: false },
            data: state.date
            }
        ],
        yAxis: [
            {
            type: 'value',
            }
        ],
        series: [
                {
                name: '销售额',
                type: 'bar',
                barGap: 0,
                emphasis: {
                    focus: 'series'
                },
                data: state.sale_money
                },
                
                {
                name: '商家实收',
                type: 'bar',
                emphasis: {
                    focus: 'series'
                },
                data: state.business_money
                },
        ]
    };
    
    option && myChart.setOption(option);
}
// 方法：显示下一个规则，或处理同意操作
const nextRule = () => {
    if (state.currentRuleIndex < shopRuleData.length) {
        // 显示当前规则
        state.dialogStandardVisible = true;
    } else {
        // 所有规则已处理完毕
        state.dialogStandardVisible = false;
    }
}
const submitVersion = async () => {
    const rule = shopRuleData[state.currentRuleIndex]; // 当前规则
    const { rule_id } = rule
    //调用接口传递版本号
    const { code, msg } = await updateVersionApi(rule_id) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    proxy.$message({ type: 'success', message: '授权成功' })
    store.commit(UserMutationTypes.MINUS_MENU_WARNING_ITEM, 'instationMsgWarn')
    store.commit(UserMutationTypes.MINUS_MENU_WARNING_ITEM, 'rule_auths')
    //判断是否点击过同意
    sessionStorage.setItem(`isStandardAgree_${rule_id}`, '1');
    //关闭弹窗
    state.dialogStandardVisible = false;
    // 关闭当前对话框并准备显示下一个
    state.currentRuleIndex++;
    nextRule();
}
// 弹框倒计时
const timeCount = ref(10) as any
let timer = setInterval(() => {
    timeCount.value--
    if (timeCount.value <= 0) {
        timeCount.value = null
        clearInterval(timer)
    }
}, 1000)

const isBottom = ref(false)
const scrollerHeight = ref<number>(400)
nextTick(() => {
    // 获取子容器高度
    const childElHeight = proxy.$refs.innerRef?.clientHeight
    // 子容器高度 - 父容器高度 = 可滚动高度
    const scrollableHeight = childElHeight - scrollerHeight.value
    if (scrollableHeight <= 20) { // 留有一定空间，防止出现滚动高度问题
        isBottom.value = true
    }
})
const scrollBehavior = ({ scrollTop }) => {
    // 获取子容器高度
    const childElHeight = proxy.$refs.innerRef.clientHeight
    // 子容器高度 - 父容器高度 = 可滚动高度
    const scrollableHeight = childElHeight - scrollerHeight.value
    // 判断已滚动距离是否大于等于可滚动高度
    if (scrollTop >= scrollableHeight) {
        isBottom.value = true
    }
}

watch([() => timeCount.value, () => isBottom.value], (newvalue, oldvalue) => {
    //如果倒计时结束且滚动到底部同意按钮显示
    if (newvalue[0] === null && newvalue[1] === true) {
        agree.value = false
    }
})
const checkRulesAndDisplayDialog = () => {
    let allAgreed = true;
    for (let i = 0; i < shopRuleData.length; i++) {
        const rule = shopRuleData[i];
        if (!sessionStorage.getItem(`isStandardAgree_${rule.rule_id}`)) {
            allAgreed = false;
            state.currentRuleIndex = i;
            nextRule();
            break;
        }
    }

    if (allAgreed) {
        state.dialogStandardVisible = false;
    }
}

//判断规范弹框是否显示   不需要使用is_new进行版本号的判断
// @ts-ignore     
if (shopRuleData) {
    checkRulesAndDisplayDialog()
    // state.dialogStandardVisible = true;
}
//当前时间
const  currentDate = ref()
//上次打开弹窗时间
const lastCookieTime = ref()
//判断库存不足下架商品提醒弹框是否显示
// @ts-ignore
if (StockMsg) {
    // 获取当前时间并格式化
    let currentDate = dateFormat(new Date()) as any
    // 获取缓存时间
    let cacheDate = localStorage.getItem('last-dialog-stock-time') as any
    //如果没有上次记录的操作时间或者当前时间大于上次弹出的时间则弹出弹框
    if (!localStorage.getItem('last-dialog-stock-time') || currentDate > cacheDate) {
        state.dialogStockVisible = true;
        // 设置 cookie，记录当前操作时间
        localStorage.setItem('last-dialog-stock-time',currentDate);
    }
}
//判断资质提醒弹框是否显示
// @ts-ignore
if (staleDatedMsg) {
    // 获取当前时间并格式化
    let currentDate = dateFormat(new Date()) as any
    // 获取缓存时间
    let cacheDate = localStorage.getItem('last-dialog-certification-time') as any
    //如果没有上次记录的操作时间或者当前时间大于上次弹出的时间则弹出弹框
    if (!localStorage.getItem('last-dialog-certification-time') || currentDate > cacheDate) {
        state.dialogStaleDatedVisible = true;
        // 设置 cookie，记录当前操作时间
        localStorage.setItem('last-dialog-certification-time',currentDate);
    }
}
//判断未付款品牌提醒
if(obligationMsg){
    state.dialogBrandVisible = true;
}
//判断是否有商家评级有提醒
if(ratingMsg){
    state.dialogRatingVisible = true
}
//判断未对账提醒
if(reconciliationMsg){
    state.dialogReconciliationVisible = true;
}
// 下载资质模板
const onDownload = (type:number) => {
    type == 1
    ? window.open('https://trade.dangaoss.cn/uploads/goods/商户合作协议书模板.doc')
    : window.open('https://trade.dangaoss.cn/uploads/goods/授权书模板.docx')
}

// 判断是否存在因延迟发货被下架商品
const checkDelayProduct = async () => {
    const { code, data, msg } = await existDelayProductApi() as any
    // @ts-ignore
    if (UserType[user_type] === '合作商户' && parent_id == 0 && Boolean(data.is_goods_msg)) {
        proxy.$confirm('您有因延迟发货造成的下架商品，请立即处理', '提示', {
            type: 'warning'
        }).then(() => {
            router.push('/merchant-admin/off-product-list')
        }).catch(() => {
            console.log('取消操作')
        })
    }
}
// @ts-ignore
if (UserType[user_type] === '合作商户' && parent_id == 0) {
    checkDelayProduct()
}

// 跳转到商品详情页，同时添加缓存
const toProductList = () => {
    localStorage.setItem('cakeCat', '1')
    router.push('/merchant-admin/product-list')
}
onMounted(() => {
    // 假设 today 已经定义为今天的日期
    const today = new Date();

    // 创建一个表示昨天的新 Date 对象
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    // 现在使用 dateFormat 函数来格式化昨天的日期
    //@ts-ignore
    finance.end_time= dateFormat(yesterday);
    financeFilters.end_time = dateFormat(yesterday);
    newFilters.end_date = dateFormat(yesterday);
    // 如果当前登录用户为蛋糕类商户且没有去完善的缓存，则弹框提示去完善
    if (is_cat && !localStorage.getItem('cakeCat')) {
        state.dialogCakeCatVisible = true
    }
    // if(user_type == 2){
     //  getList()
    //     getNoticeList()
    // }
    // getCorrelationList()
    //判断只有财务角色才调用
    // if(userGroups.includes('5')){
    //     getFinanceList()
    // }
    // window.onload = function(){
    //     router.push('/datacenter/merchant')
    // }
    // nextTick(() => {
    // })
    // if(user_type == 2){
    //     router.push('/datacenter/merchant')
    // }
})

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_affix = _resolveComponent("el-affix")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (showWxBindTip.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_el_icon, { class: "tip-icon" }, {
            default: _withCtx(() => [
              _createVNode(_unref(WarningFilled))
            ]),
            _: 1
          }),
          _cache[34] || (_cache[34] = _createElementVNode("span", { class: "tip-text" }, "提高账号安全性，点击授权微信后，即可扫码登录", -1)),
          _createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            onClick: goWxAuth,
            class: "tip-btn"
          }, {
            default: _withCtx(() => _cache[33] || (_cache[33] = [
              _createTextVNode("立即授权")
            ])),
            _: 1
          }),
          _createVNode(_component_el_icon, {
            class: "tip-close",
            onClick: dismissWxTip
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Close))
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (!_unref(userGroups).includes('5') && _unref(user_id) !='2')
      ? (_openBlock(), _createElementBlock("img", _hoisted_3))
      : _createCommentVNode("", true),
    (!_unref(userGroups).includes('5') && _unref(user_id) !='2')
      ? (_openBlock(), _createElementBlock("h1", _hoisted_4, "爱，让生活更甜蜜"))
      : _createCommentVNode("", true),
    (_unref(user_type)==22)
      ? (_openBlock(), _createBlock(_component_el_affix, {
          key: 3,
          offset: 0,
          style: {"background-color":"#fff","justify-content":"center"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { style: {"margin-top":"10px","padding":"20px","display":"flex","align-items":"center"} }, {
              default: _withCtx(() => [
                (state.level)
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 0,
                      span: 1,
                      style: {"margin-right":"10px"}
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, _toDisplayString(state.level) + "级 ", 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_col, { span: 3 }, {
                  default: _withCtx(() => [
                    _createVNode(SelectBrand, {
                      class: "filter-item",
                      style: {"margin-right":"10px"},
                      ifBody: 0,
                      onBrandChange: onBrandChange
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _cache[35] || (_cache[35] = _createElementVNode("span", { class: "text" }, "选择日期：", -1)),
                      _createVNode(_component_el_date_picker, {
                        class: "filter-item",
                        type: "date",
                        modelValue: filters.start_time,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.start_time) = $event)),
                        "disabled-date": disabledStartDate,
                        placeholder: "开始日期",
                        "value-format": "YYYY-MM-DD",
                        style: {"width":"170px"},
                        clearable: ""
                      }, null, 8, ["modelValue"]),
                      _cache[36] || (_cache[36] = _createElementVNode("span", { class: "text" }, " - ", -1)),
                      _createVNode(_component_el_date_picker, {
                        class: "filter-item",
                        type: "date",
                        modelValue: filters.end_time,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.end_time) = $event)),
                        "disabled-date": disabledEndDate,
                        placeholder: "结束日期",
                        "value-format": "YYYY-MM-DD",
                        style: {"width":"170px"},
                        clearable: ""
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 5 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_el_button, {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (onDay(2)))
                      }, {
                        default: _withCtx(() => _cache[37] || (_cache[37] = [
                          _createTextVNode("近七日")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (onDay(3)))
                      }, {
                        default: _withCtx(() => _cache[38] || (_cache[38] = [
                          _createTextVNode("近30天")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        class: "filter-btn",
                        type: "primary",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (search()))
                      }, {
                        default: _withCtx(() => _cache[39] || (_cache[39] = [
                          _createTextVNode("搜索")
                        ])),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_el_carousel, {
                        height: "50px",
                        direction: "vertical",
                        autoplay: _ctx.shouldAutoplay,
                        interval: 2000
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(noticeDate.value, (item, id) => {
                            return (_openBlock(), _createBlock(_component_el_carousel_item, { key: id }, {
                              default: _withCtx(() => [
                                _createElementVNode("h3", {
                                  class: "small justify-center",
                                  text: "2xl",
                                  onClick: ($event: any) => (toNotice(item.id,'edit'))
                                }, _toDisplayString(item.title), 9, _hoisted_9),
                                (item.is_red == 1)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, "已读"))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_11, "未读"))
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["autoplay"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(user_type)==22)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, "数据更新时间：" + _toDisplayString(state.new_data), 1))
      : _createCommentVNode("", true),
    (_unref(user_type)==22)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_13, _cache[40] || (_cache[40] = [
          _createStaticVNode("<div class=\"loading-content\" data-v-5c88bbaa><div class=\"loading-text\" data-v-5c88bbaa><div class=\"fade-in-text\" data-v-5c88bbaa><span class=\"bold-text\" data-v-5c88bbaa>盯屏幕这么久了，歇息一下~</span><br data-v-5c88bbaa><span class=\"loading-message\" data-v-5c88bbaa>蛋叔正在全力为你加载数据~</span></div></div><div class=\"loading-spinner\" data-v-5c88bbaa></div></div>", 1)
        ]), 512)), [
          [_vShow, state.isLoading]
        ])
      : _createCommentVNode("", true),
    (_unref(user_type)==22)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", {
                  class: "show",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (toOrderAll('order','3')))
                }, [
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_el_icon, {
                      class: "custom-icon",
                      color: "#6ddb60"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(DocumentCopy))
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", null, _toDisplayString(state.order_count), 1)
                  ]),
                  _cache[41] || (_cache[41] = _createElementVNode("div", { class: "show_text" }, [
                    _createElementVNode("span", null, "订单数量")
                  ], -1))
                ]),
                _createElementVNode("div", {
                  class: "show",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (toOrder('order','1')))
                }, [
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_el_icon, {
                      class: "custom-icon",
                      color: "#6ddbff"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Loading))
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", null, _toDisplayString(state.delivery_count), 1)
                  ]),
                  _cache[42] || (_cache[42] = _createElementVNode("div", { class: "show_text" }, [
                    _createElementVNode("span", null, "待发货订单")
                  ], -1))
                ]),
                _createElementVNode("div", {
                  class: "show",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (toOrder('order','2')))
                }, [
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_el_icon, {
                      class: "custom-icon",
                      color: "#6d73bf"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Clock))
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", null, _toDisplayString(state.unshipped_count), 1)
                  ]),
                  _cache[43] || (_cache[43] = _createElementVNode("div", { class: "show_text" }, [
                    _createElementVNode("span", null, "48h未发货订单")
                  ], -1))
                ]),
                _createElementVNode("div", {
                  class: "show",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (toBadOrder('bad',2)))
                }, [
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_el_icon, {
                      class: "custom-icon",
                      color: "#ed2a0b"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(DocumentDelete))
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", null, _toDisplayString(state.bad_count), 1)
                  ]),
                  _cache[44] || (_cache[44] = _createElementVNode("div", { class: "show_text" }, [
                    _createElementVNode("span", null, "差评订单")
                  ], -1))
                ]),
                _createElementVNode("div", {
                  class: "show",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (toProduct('product','1')))
                }, [
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_el_icon, {
                      class: "custom-icon",
                      color: "#ff7d7d"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(DocumentChecked))
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", null, _toDisplayString(state.sale_count), 1)
                  ]),
                  _cache[45] || (_cache[45] = _createElementVNode("div", { class: "show_text" }, [
                    _createElementVNode("span", null, "在售商品")
                  ], -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", {
                  class: "show",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (toFine('fine')))
                }, [
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_el_icon, {
                      class: "custom-icon",
                      color: "#fedb60"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Stamp))
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", null, _toDisplayString(state.fine_count), 1)
                  ]),
                  _cache[46] || (_cache[46] = _createElementVNode("div", { class: "show_text" }, [
                    _createElementVNode("span", null, "罚款金额")
                  ], -1))
                ]),
                _createElementVNode("div", {
                  class: "show",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (toSale('sale')))
                }, [
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_el_icon, {
                      class: "custom-icon",
                      color: "#addb60"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Sell))
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", null, _toDisplayString(state.sale_money_count), 1)
                  ]),
                  _cache[47] || (_cache[47] = _createElementVNode("div", { class: "show_text" }, [
                    _createElementVNode("span", null, "销售金额")
                  ], -1))
                ]),
                _createElementVNode("div", {
                  class: "show",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (toSale('sale')))
                }, [
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_component_el_icon, {
                      class: "custom-icon",
                      color: "#6dff60"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Ticket))
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", null, _toDisplayString(state.customer_price_count), 1)
                  ]),
                  _cache[48] || (_cache[48] = _createElementVNode("div", { class: "show_text" }, [
                    _createElementVNode("span", null, "客单价")
                  ], -1))
                ]),
                _createElementVNode("div", {
                  class: "show",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (toSale('sale')))
                }, [
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_el_icon, {
                      class: "custom-icon",
                      color: "#6fab60"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Avatar))
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", null, _toDisplayString(state.business_money_count), 1)
                  ]),
                  _cache[49] || (_cache[49] = _createElementVNode("div", { class: "show_text" }, [
                    _createElementVNode("span", null, "商家实收")
                  ], -1))
                ]),
                _createElementVNode("div", {
                  class: "show",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (toCheck('check')))
                }, [
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(_component_el_icon, {
                      class: "custom-icon",
                      color: "#ed2a0b"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Tools))
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", null, _toDisplayString(state.check_count), 1)
                  ]),
                  _cache[50] || (_cache[50] = _createElementVNode("div", { class: "show_text" }, [
                    _createElementVNode("span", null, "待审核商品")
                  ], -1))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _cache[51] || (_cache[51] = _createElementVNode("div", { class: "member" }, [
              _createElementVNode("div", { class: "tag" }),
              _createElementVNode("span", null, "下架数据")
            ], -1)),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", {
                  style: _normalizeStyle([{"width":"50%"}, { width: '350px', height: '300px' }]),
                  class: "left",
                  id: "system_dialog"
                }),
                _createElementVNode("div", {
                  style: _normalizeStyle([{"width":"50%"}, { width: '350px', height: '300px' }]),
                  class: "right",
                  id: "operate_dialog"
                }),
                _createElementVNode("div", {
                  style: _normalizeStyle([{"width":"50%"}, { width: '350px', height: '300px' }]),
                  class: "shelf_down",
                  id: "removal_dialog"
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _cache[54] || (_cache[54] = _createElementVNode("div", { class: "member" }, [
              _createElementVNode("div", { class: "tag" }),
              _createElementVNode("span", null, "其他数据")
            ], -1)),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _cache[52] || (_cache[52] = _createElementVNode("div", { style: {"font-size":"18px","font-weight":"800","text-align":"center","margin-bottom":"10px"} }, "商品排行榜", -1)),
                _createVNode(_component_el_table, {
                  data: state.table_data,
                  stripe: "",
                  border: "",
                  width: "400px"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      prop: "rank",
                      width: "80px",
                      label: "排行"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "location",
                      label: "商品id"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "category_count",
                      label: "商品名称"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "category_rate",
                      label: "销售额"
                    })
                  ]),
                  _: 1
                }, 8, ["data"])
              ]),
              _cache[53] || (_cache[53] = _createElementVNode("div", {
                class: "right",
                id: "member_user",
                style: { width: '850px', height: '400px' }
              }, null, -1))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(userGroups).includes('5') || _unref(user_id)=='6717' || _unref(user_id)=='2')
      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
          _cache[63] || (_cache[63] = _createElementVNode("div", { class: "box" }, [
            _createElementVNode("div", { class: "member" }, [
              _createElementVNode("div", { class: "tag" }),
              _createElementVNode("span", null, "平台数据")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_36, [
            _cache[56] || (_cache[56] = _createElementVNode("span", { class: "text" }, "选择日期：", -1)),
            _createVNode(_component_el_date_picker, {
              class: "filter-item",
              type: "date",
              modelValue: financeFilters.start_time,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((financeFilters.start_time) = $event)),
              placeholder: "开始日期",
              "value-format": "YYYY-MM-DD",
              style: {"width":"170px"},
              clearable: ""
            }, null, 8, ["modelValue"]),
            _cache[57] || (_cache[57] = _createElementVNode("span", { class: "text" }, " - ", -1)),
            _createVNode(_component_el_date_picker, {
              class: "filter-item",
              type: "date",
              modelValue: financeFilters.end_time,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((financeFilters.end_time) = $event)),
              placeholder: "结束日期（包含当天）",
              "disabled-date": disabledFinanceEndDate,
              "value-format": "YYYY-MM-DD",
              style: {"width":"170px"},
              clearable: ""
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_button, {
              class: "filter-btn",
              type: "primary",
              style: {"margin-left":"15px"},
              onClick: _cache[17] || (_cache[17] = ($event: any) => (searchFinance()))
            }, {
              default: _withCtx(() => _cache[55] || (_cache[55] = [
                _createTextVNode("查询")
              ])),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _createVNode(_component_el_icon, {
                      class: "custom-icon",
                      color: "#6ddb60"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(DocumentCopy))
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", _hoisted_42, _toDisplayString(finance.cake_total_amount), 1)
                  ]),
                  _cache[58] || (_cache[58] = _createElementVNode("div", { class: "show_text" }, [
                    _createElementVNode("span", null, "订单实物（总）")
                  ], -1))
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, [
                    _createVNode(_component_el_icon, {
                      class: "custom-icon",
                      color: "#6ddbff"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(VideoCameraFilled))
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", _hoisted_45, _toDisplayString(finance.movie_total_amount), 1)
                  ]),
                  _cache[59] || (_cache[59] = _createElementVNode("div", { class: "show_text" }, [
                    _createElementVNode("span", null, "电影（总）")
                  ], -1))
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _createVNode(_component_el_icon, {
                      class: "custom-icon",
                      color: "#6dff60"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Ticket))
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", _hoisted_48, _toDisplayString(finance.coupon_total_amount), 1)
                  ]),
                  _cache[60] || (_cache[60] = _createElementVNode("div", { class: "show_text" }, [
                    _createElementVNode("span", null, "电子券（总）")
                  ], -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("span", null, _toDisplayString(finance.brand_count), 1)
                    ]),
                    _cache[61] || (_cache[61] = _createElementVNode("div", { class: "show_text" }, [
                      _createElementVNode("span", null, "活跃商家（个）")
                    ], -1))
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("span", null, _toDisplayString(finance.user_count), 1)
                    ]),
                    _cache[62] || (_cache[62] = _createElementVNode("div", { class: "show_text" }, [
                      _createElementVNode("span", null, "活跃用户（人）")
                    ], -1))
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      title: "系统更新提示",
      modelValue: sysDialog.value,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((sysDialog).value = $event))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_55, [
          _createVNode(_component_el_button, {
            onClick: _cache[18] || (_cache[18] = ($event: any) => (sysDialog.value = false))
          }, {
            default: _withCtx(() => _cache[64] || (_cache[64] = [
              _createTextVNode("取 消")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[19] || (_cache[19] = ($event: any) => (sysDialog.value = false))
          }, {
            default: _withCtx(() => _cache[65] || (_cache[65] = [
              _createTextVNode("确 定")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _cache[66] || (_cache[66] = _createElementVNode("div", { class: "sys-dialog-content" }, [
          _createElementVNode("div", null, [
            _createTextVNode("当前系统将于 "),
            _createElementVNode("b", null, "2023年4月3日 19:00-21:00"),
            _createTextVNode(" 进行更新优化，期间部分功能可能存在波动，请进行刷新操作或耐心等待更新结束。本次更新功能如下：")
          ]),
          _createElementVNode("div", null, "一．新订单消息提醒功能"),
          _createElementVNode("div", null, "二．商品管理"),
          _createElementVNode("div", null, "三．商户订单管理-商户备注"),
          _createElementVNode("div", null, "四．商家培训功能"),
          _createElementVNode("div", null, "五．商户资质上传"),
          _createElementVNode("div", null, "六．商户管理规范"),
          _createElementVNode("div", null, "七．发票管理"),
          _createElementVNode("div", null, "八．门店管理"),
          _createElementVNode("div", null, [
            _createTextVNode("具体更新内容请查阅"),
            _createElementVNode("a", {
              href: "https://dgss-oss-zs.oss-cn-beijing.aliyuncs.com/channel_contracts/商户后台操作手册(1)1680514248.docx",
              _target: "blank"
            }, "《操作手册》"),
            _createTextVNode("，感谢您的配合")
          ])
        ], -1))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: state.dialogStandardVisible,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((state.dialogStandardVisible) = $event)),
      "close-on-click-modal": false,
      center: "",
      "show-close": false
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_56, _toDisplayString(_unref(shopRuleData)[state.currentRuleIndex]?.title), 1)
      ]),
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_59, [
          _createVNode(_component_el_button, {
            type: "primary",
            disabled: agree.value,
            onClick: submitVersion
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 同意" + _toDisplayString(timeCount.value), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_scrollbar, {
          height: scrollerHeight.value,
          onScroll: scrollBehavior
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", {
                innerHTML: _unref(shopRuleData)[state.currentRuleIndex]?.desc
              }, null, 8, _hoisted_58)
            ], 512)
          ]),
          _: 1
        }, 8, ["height"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "温馨提示",
      modelValue: state.dialogStaleDatedVisible,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((state.dialogStaleDatedVisible) = $event))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_61, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[22] || (_cache[22] = ($event: any) => (onDownload(1)))
          }, {
            default: _withCtx(() => _cache[67] || (_cache[67] = [
              _createTextVNode("下载合作协议模板")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[23] || (_cache[23] = ($event: any) => (onDownload(2)))
          }, {
            default: _withCtx(() => _cache[68] || (_cache[68] = [
              _createTextVNode("下载授权书模板")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, { type: "primary" }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, {
                style: {"color":"#fff"},
                to: "/qualification/list"
              }, {
                default: _withCtx(() => _cache[69] || (_cache[69] = [
                  _createTextVNode("立即更新资质")
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_60, _toDisplayString(_unref(staleDatedMsg)), 1)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "温馨提示",
      modelValue: state.dialogStockVisible,
      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((state.dialogStockVisible) = $event))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_63, [
          _createVNode(_component_el_button, { type: "primary" }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, {
                style: {"color":"#fff"},
                to: "/merchant-admin/product-list?type=9"
              }, {
                default: _withCtx(() => _cache[70] || (_cache[70] = [
                  _createTextVNode("查看商品")
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_62, _toDisplayString(_unref(StockMsg)), 1)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "温馨提示",
      modelValue: state.dialogCakeCatVisible,
      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((state.dialogCakeCatVisible) = $event)),
      "show-close": false,
      center: ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_64, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: toProductList
          }, {
            default: _withCtx(() => _cache[71] || (_cache[71] = [
              _createTextVNode("立即去完善")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _cache[72] || (_cache[72] = _createElementVNode("div", {
          class: "content",
          style: {"font-size":"15px","color":"#666"}
        }, [
          _createElementVNode("p", { style: {"text-indent":"0"} }, "尊敬的各位商家："),
          _createElementVNode("p", null, "为了更好的展示商品，突出商品特质，8月将对蛋糕叔叔平台页面进行优化，现需要对商品进行重新分类"),
          _createElementVNode("p", null, "分类："),
          _createElementVNode("p", null, "例如：蛋糕商品可按水果蛋糕、千层蛋糕、奶油蛋糕、巧克力蛋糕等品类进行细分"),
          _createElementVNode("p", null, "操作流程："),
          _createElementVNode("p", null, "登录蛋糕叔叔后台--点击商品--点击编辑--选择商品分类--点击提交"),
          _createElementVNode("br"),
          _createElementVNode("p", null, "PS:"),
          _createElementVNode("p", null, "①更改商品分类不需要运营审核，直接提交即可"),
          _createElementVNode("p", null, "②分类具有唯一性，一个商品不可多选"),
          _createElementVNode("p", null, "辛苦各位于8月5日前更改完毕，修改完毕后群内或私聊通知蛋叔运营范逸楠。"),
          _createElementVNode("p", null, "如您未做修改，8月5日后商城改版，您的商品将会无法展示到页面，会影响咱们的销量哦~")
        ], -1))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "温馨提示",
      modelValue: state.dialogBrandVisible,
      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((state.dialogBrandVisible) = $event))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_66, [
          _createVNode(_component_el_button, { type: "primary" }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, {
                style: {"color":"#fff"},
                to: "/invoice/invoice-check"
              }, {
                default: _withCtx(() => _cache[73] || (_cache[73] = [
                  _createTextVNode("查看发票")
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_65, _toDisplayString(_unref(obligationMsg)), 1)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "温馨提示",
      modelValue: state.dialogReconciliationVisible,
      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((state.dialogReconciliationVisible) = $event))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_68, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[28] || (_cache[28] = ($event: any) => (state.dialogReconciliationVisible = false))
          }, {
            default: _withCtx(() => _cache[74] || (_cache[74] = [
              _createTextVNode("知道了")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_67, _toDisplayString(_unref(reconciliationMsg)), 1)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "温馨提示",
      modelValue: state.dialogRatingVisible,
      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((state.dialogRatingVisible) = $event))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_70, [
          _createVNode(_component_el_button, { type: "primary" }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, {
                style: {"color":"#fff"},
                to: "/merchant-admin/product-list"
              }, {
                default: _withCtx(() => _cache[75] || (_cache[75] = [
                  _createTextVNode("查看商品")
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_69, _toDisplayString(_unref(ratingMsg)), 1)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "温馨提示",
      modelValue: _unref(showFineAppealDialog),
      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_isRef(showFineAppealDialog) ? (showFineAppealDialog).value = $event : null)),
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      center: "",
      "align-center": "",
      "show-close": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_72, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: setSessionAndRedirect
          }, {
            default: _withCtx(() => _cache[77] || (_cache[77] = [
              _createTextVNode("去处理")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_71, [
          _createElementVNode("p", null, "检测到当前您有" + _toDisplayString(_unref(timeout_count)) + "条未审核的申诉罚款数据", 1),
          _cache[76] || (_cache[76] = _createElementVNode("p", null, "已超过3天，请务必前往处理审核", -1))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_unref(UserType)[_unref(user_type)] === '合作商户')
      ? (_openBlock(), _createBlock(MerchantQualificationDialog, {
          key: 8,
          modelValue: merchantQualificationDialogShow.value,
          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((merchantQualificationDialogShow).value = $event)),
          closable: _unref(is_contracts) !== 3
        }, null, 8, ["modelValue", "closable"]))
      : _createCommentVNode("", true)
  ]))
}
}

})